var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRisers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H8V2H10V0H12V2H13C13.5523 2 14 2.44772 14 3C14 3.55228 13.5523 4 13 4H12V14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H12V18H10V16H8V18H6V16H4V18H2V16H1C0.447716 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H2V4H1C0.447716 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H2V0H4V2H6V0ZM4 14H6V4H4V14ZM8 14H10V4H8V14Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRisers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/risers.afa6824e.svg";
export { ForwardRef as ReactComponent };